import styled, { css } from "styled-components";
import { device, breakpoints, getWidthRange } from '../../../../../app/js/utils/responsive_utilities';
import { fontQuicksand } from '../../../common/mixins/mixin';
import { CTAOfferButton } from "../../../common/styled-components/styled-components";
import { FormHeading, Heading1, SubHeading } from "../../../common/styled-components/styled-components"
import { deepCoveDark, mintGreen, orange, indigo, white, darkBlue, midGrayDark } from '../../../../../app/js/components/loggedout/shared-styles/Colors';

export const Container = styled.div`
  width: 100%;
  margin: auto;
  
  & > form{
    width: 100%;
    margin-top: 2.4rem;
  }
  background : ${deepCoveDark};
  box-sizing: border-box;

  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    height: 100%;
  }
`

export const MessageBox = styled.div`
  p{
    ${fontQuicksand(1.2, 1.5, 5)};
    margin: 0.5rem 0;

    ${props => props.isError ? `
      color: ${orange};
      text-align: right;
    ` : `
      color: ${mintGreen};
      text-align: left;
    `}

    ${props => props.isFormError && "margin-top: 2rem;text-align: center;"}

    @media ${device.Desktop}{
      ${props => !props.isError && fontQuicksand(1.4, 1.7, 5)}
    }
  }
`

export const HelperText = styled.div`
  color: ${indigo};
  ${fontQuicksand(1.1, 1.5, 6)};
  margin-top: 1.2rem;

`

export const PasswordFormHeading = styled(Heading1)`
  ${fontQuicksand(2.2, 2.9, 7)};
`

export const PasswordSubHeading = styled(SubHeading)`
  ${fontQuicksand(1.1, 1.4, 5)};
`

export const Heading = styled(FormHeading)`
  ${fontQuicksand(1.6, 2, 7)};
  text-align: left;

  @media ${device.Desktop} {
    ${fontQuicksand(2.4, 3, 7)};
  }
`

export const CTAButton = styled(CTAOfferButton)`
    background : ${(props) => props.isButtonDisabled ? indigo : white};
    pointer-events: ${(props) => props.isButtonDisabled ? "none" : "all"};
    display: block;
    margin : 5.2rem auto 2rem auto;
    cursor: pointer;
    a{
      color : ${darkBlue};
    }
    ${props => props.campaignBasedCustomization && css`
      line-height: 2.4rem;
      background-color: ${white};
      a {
        padding-top: 1rem;
        p {
          ${fontQuicksand(1, 1, 4)};
          color: ${midGrayDark};
          margin: 0;
        }
      }
    `}

    &:hover{
      background: ${props => props.isButtonDisabled ? indigo : white};
    }

    @media ${device.Desktop} {
      margin: 10.3rem auto 5rem auto
    }
`

export const Wrapper = styled.div`
  margin-top: 3rem;
  @media ${device.Tablet}{
    margin: 5rem auto 0rem;
  }

  @media ${device.PhoneLargeScreen} {
    margin: 3rem auto 0rem;

  }
  @media (min-width: ${breakpoints.lg}px) {
      flex-grow: 1;
    }
`;

export const PurchaseWrapper = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    flex-grow: 1;
  }
`;

export const ImageWrapper = styled.div`
    width: 1.3rem;
    height: 1rem;
    margin : 0.5rem 0rem;
  img {
    width: 100%;
    height: 100%;
  }
`